import { officeOrderModalConstants } from "./constants";

export const openOfficeOrderModal = ({
    orderId,
    officeId,
    activeTab = "overview",
    activePanel = "",
    source = "",
    sourceTitle = "",
    backPayload = null,
    payload = null,
} = {}) => ({
    type: officeOrderModalConstants.OFFICE_ORDER_MODAL_OPEN,
    payload: {
        orderId,
        officeId,
        activeTab,
        activePanel,
        source,
        sourceTitle,
        backPayload,
        payload,
        openedAt: Date.now(),
    },
});

export const closeOfficeOrderModal = () => ({
    type: officeOrderModalConstants.OFFICE_ORDER_MODAL_CLOSE,
});

export const setOfficeOrderModalTab = (activeTab) => ({
    type: officeOrderModalConstants.OFFICE_ORDER_MODAL_SET_TAB,
    payload: activeTab,
});

export const setOfficeOrderModalPanel = (activePanel) => ({
    type: officeOrderModalConstants.OFFICE_ORDER_MODAL_SET_PANEL,
    payload: activePanel,
});

export const patchOfficeOrderModal = (payload = {}) => ({
    type: officeOrderModalConstants.OFFICE_ORDER_MODAL_PATCH,
    payload,
});